import PRIVILEGE from '../core/constants/privilege';
import SETTING from '../core/constants/setting';
import SCOPE from '../core/constants/scope';
import { checkAndPermission } from '../utils/permission';

const SCOPE_NOT_SELF = [
  SCOPE.department,
  SCOPE.departmentAndSub,
  SCOPE.all,
  SCOPE.departmentOwnAndSub,
  SCOPE.departmentUnionOwnAndSub,
];

export default [
  {
    id: 'dashboard',
    icon: 'dashboard',
    system: 'CRM',
    url: '/dashboard',
    roles: [PRIVILEGE.functionalBase],
  },
  {
    id: 'mail',
    icon: 'mail',
    system: 'MAIL_PRO',
    url: '',
    roles: [PRIVILEGE.mailView],
  },
  {
    id: 'leads',
    icon: 'lead',
    roles: [PRIVILEGE.functionalBase],
    subMenu: [
      {
        id: 'leadsList',
        system: 'CRM',
        url: '/leads/list',
        roles: [PRIVILEGE.leadPrivateView],
      },
      {
        id: 'leadsPublic',
        system: 'CRM',
        url: '/leads/public',
        roles: [PRIVILEGE.leadPoolView],
      },
      {
        id: 'leadsReports',
        system: 'CRM',
        url: '/leads/reports',
        roles: [PRIVILEGE.leadPrivateReport],
      },
    ],
  },
  {
    id: 'customer',
    icon: 'crm',
    roles: [PRIVILEGE.functionalBase],
    subMenu: [
      {
        id: 'customerList',
        system: 'CRM',
        url: '/customer/list',
        roles: [PRIVILEGE.companyPrivateView],
      },
      {
        id: 'customerPublic',
        system: 'CRM',
        url: '/customer/public',
        roles: [PRIVILEGE.companyPoolView],
      },
      {
        id: 'archiveAdvice',
        system: 'CRM',
        url: '/customer/archive-advice',
        roles: [PRIVILEGE.functionalAIClassifyCustomer],
      },
      {
        id: 'customerQuery',
        system: 'CRM',
        url: '/customer/query',
      },
      {
        id: 'customerConfig',
        system: 'CRM',
        url: '/config',
        roles: [PRIVILEGE.companyPrivateView, PRIVILEGE.companyPoolView],
      },
    ],
  },
  {
    id: 'opportunity',
    icon: 'opportunity',
    system: 'CRM',
    url: '/business',
    roles: [PRIVILEGE.opportunityView],
    setting: [SETTING.opportunitySwitch],
  },
  {
    id: 'cpq',
    icon: 'cpq',
    subMenu: [
      {
        id: 'product',
        system: 'CRM',
        url: '/product',
        roles: [PRIVILEGE.productView],
      },
      {
        id: 'quotation',
        system: 'CRM',
        url: '/quotation',
        roles: [PRIVILEGE.quotationView],
        setting: [SETTING.quotationSwitch],
      },
      {
        id: 'order',
        system: 'CRM',
        url: '/order',
        roles: [PRIVILEGE.orderView],
        setting: [SETTING.orderSwitch],
      },
      {
        id: 'logistics',
        system: 'CRM',
        url: '/logistics',
        roles: {
          value: [PRIVILEGE.functionalLogistics, PRIVILEGE.logisticsView],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'cashCollectionsList',
        system: 'SALES',
        url: '/cash-collections/list',
        roles: [PRIVILEGE.functionalCashCollection],
        setting: [SETTING.orderSwitch, SETTING.opportunitySwitch],
      },
      {
        id: 'paypalBill',
        system: 'SALES',
        url: '/paypalBill',
        roles: [PRIVILEGE.functionalPaypal],
      },
    ],
  },
  {
    id: 'statistic',
    icon: 'statistic',
    subMenu: [
      {
        id: 'statisticbiz',
        system: 'CRM',
        url: '/statistic/biz/panel/',
        roles: [PRIVILEGE.settingStatisticAnalyse],
      },
      {
        id: 'statisticCustom',
        system: 'CRM',
        url: '/statistic/custom/panel',
        roles: [PRIVILEGE.settingStatisticAnalyse],
      },
      // {
      //   id: 'performance',
      //   system: 'SALES',
      //   url: '/performance',
      //   roles: [PRIVILEGE.performanceView],
      // },
    ],
  },
  {
    id: 'mk',
    icon: 'mk',
    subMenu: [
      {
        id: 'myRecommend',
        system: 'DX',
        url: '/MyRecommend',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxRecommended],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'mining',
        system: 'DX',
        url: '/mining',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxMining],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'ciqDatum',
        system: 'DX',
        url: '/ciq-datum',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxCiq],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'assistant',
        system: 'DX',
        url: '/xiaoman-assistant',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxAssistant],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'subscribe',
        system: 'DX',
        url: '/subscribe',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxSubscription],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'attention',
        system: 'DX',
        url: '/attention',
        roles: {
          value: [PRIVILEGE.dxUser, PRIVILEGE.dxFollow],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'edm',
        roles: [PRIVILEGE.edmView],
        subMenu: [
          {
            id: 'edmPublish',
            system: 'MK',
            url: '/edm/publish',
          },
          {
            id: 'edmDraft',
            system: 'MK',
            url: '/edm/draft',
          },
          {
            id: 'edmAutomation',
            system: 'MK',
            url: '/edm/automation',
            roles: [PRIVILEGE.edmAuto],
          },
          {
            id: 'edmTrace',
            system: 'MK',
            url: '/edm/trace',
          },
        ],
      },
      {
        id: 'edmTool',
        roles: {
          value: [PRIVILEGE.edmView, PRIVILEGE.mkBase],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
        subMenu: [
          {
            id: 'toolTrackFile',
            system: 'MK',
            url: '/tool/file',
          },
          {
            id: 'toolTrackLink',
            system: 'MK',
            url: '/tool/link',
          },
        ],
      },
      {
        id: 'page',
        roles: {
          value: [PRIVILEGE.edmView, PRIVILEGE.mkBase],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
        subMenu: [
          {
            id: 'pageManage',
            system: 'MK',
            url: '/page/manage',
          },
          {
            id: 'pageTemplate',
            system: 'MK',
            url: '/page/template',
          },
        ],
      },
      {
        id: 'snsPublish',
        system: 'MK',
        url: '/sns/publish',
        roles: {
          value: [PRIVILEGE.edmView, PRIVILEGE.mkBase],
          handle: (value, list, user) =>
            checkAndPermission(value, { list, user }),
        },
      },
    ],
  },
  {
    id: 'ai',
    icon: 'ai',
    system: 'CRM',
    roles: [PRIVILEGE.aiUser],
    subMenu: [
      {
        id: 'aidashboard',
        system: 'CRM',
        url: '/ai/dashboard',
        roles: [PRIVILEGE.functionalAIDashboard],
      },
      {
        id: 'airecommend',
        system: 'CRM',
        url: '/ai/recommend',
        roles: [PRIVILEGE.functionalAIRecommend],
      },
      {
        id: 'aifollowup',
        system: 'CRM',
        url: '/ai/followup',
        roles: [
          PRIVILEGE.functionalAIMovePool,
          PRIVILEGE.functionalAICiq,
          PRIVILEGE.functionalAIDevelopLead,
          PRIVILEGE.functionalAIFollowLead,
        ],
      },
      {
        id: 'aiautomation',
        system: 'CRM',
        url: '/ai/automation',
        roles: [PRIVILEGE.aiSetting],
      },
    ],
  },
  {
    id: 'sales',
    icon: 'sales',
    roles: [PRIVILEGE.functionalBoss],
    subMenu: [
      {
        id: 'salesCustomerManagement',
        roles: [
          PRIVILEGE.companyPrivateView,
          PRIVILEGE.companyPoolView,
          PRIVILEGE.settingCustomerExport,
        ],
        subMenu: [
          {
            id: 'salesCustomerList',
            system: 'SALES',
            url: '/customer/list',
            roles: [PRIVILEGE.companyPrivateView],
          },
          {
            id: 'salesCustomerPublic',
            system: 'SALES',
            url: '/customer/public',
            roles: [PRIVILEGE.companyPoolView],
          },
          {
            id: 'salesCustomerExport',
            system: 'SALES',
            url: '/customer/export',
            roles: [PRIVILEGE.settingCustomerExport],
          },
        ],
      },
      {
        id: 'salesOpportunity',
        system: 'SALES',
        url: '/business',
        roles: [PRIVILEGE.opportunityView],
        setting: [SETTING.opportunitySwitch],
      },
      {
        id: 'salesProduct',
        system: 'SALES',
        url: '/product',
        roles: [PRIVILEGE.settingProductManage],
      },
      {
        id: 'statisticsManagement',
        system: 'CRM',
        url: '/statistic/setting/custom-report/list',
        roles: [PRIVILEGE.settingStatisticManage],
      },
      {
        id: 'information',
        roles: [
          {
            key: PRIVILEGE.orderView,
            scope: SCOPE_NOT_SELF,
          },
          {
            key: PRIVILEGE.quotationView,
            scope: SCOPE_NOT_SELF,
          },
          {
            key: PRIVILEGE.edmView,
            scope: SCOPE_NOT_SELF,
          },
          {
            key: PRIVILEGE.mailView,
            scope: SCOPE_NOT_SELF,
          },
          PRIVILEGE.functionalStructure,
        ],
        subMenu: [
          {
            id: 'informationMail',
            system: 'SALES',
            url: '/information/mail',
            roles: [
              {
                key: PRIVILEGE.mailView,
                scope: SCOPE_NOT_SELF,
              },
            ],
          },
          {
            id: 'informationQuotation',
            system: 'SALES',
            url: '/information/quotation',
            roles: [
              {
                key: PRIVILEGE.quotationView,
                scope: SCOPE_NOT_SELF,
              },
            ],
            setting: [SETTING.quotationSwitch],
          },
          {
            id: 'informationOrder',
            system: 'SALES',
            url: '/information/order',
            roles: [
              {
                key: PRIVILEGE.orderView,
                scope: SCOPE_NOT_SELF,
              },
            ],
            setting: [SETTING.orderSwitch],
          },
          {
            id: 'informationEdm',
            system: 'SALES',
            url: '/information/edm',
            roles: [
              {
                key: PRIVILEGE.edmView,
                scope: SCOPE_NOT_SELF,
              },
            ],
          },
          {
            id: 'informationSales',
            system: 'SALES',
            url: '/sales/list/0',
            roles: [PRIVILEGE.functionalStructure],
          },
        ],
      },
      {
        id: 'processManagement',
        system: 'SALES',
        subMenu: [
          {
            id: 'workflow',
            system: 'SALES',
            url: '/manage/workflow',
            roles: [PRIVILEGE.workflow],
          },
          {
            id: 'approvalFlow',
            system: 'SALES',
            url: '/manage/approval-flow',
            roles: [PRIVILEGE.approvalFlow],
          },
        ],
      },
      {
        id: 'setting',
        roles: [
          PRIVILEGE.settingAccountRelation,
          PRIVILEGE.settingPrivilegeManage,
          PRIVILEGE.settingOriginManage,
          PRIVILEGE.settingModuleManage,
          PRIVILEGE.settingFieldsManage,
          PRIVILEGE.settingFieldsManage,
          PRIVILEGE.settingEmailManage,
          PRIVILEGE.settingEmailTemplate,
          PRIVILEGE.settingEmailReview,
          PRIVILEGE.settingCustomerManage,
          PRIVILEGE.settingOpportunityManage,
          PRIVILEGE.settingProductManage,
          PRIVILEGE.settingQuotationManage,
          PRIVILEGE.settingQuotationTemplate,
          PRIVILEGE.settingOrderManage,
          PRIVILEGE.settingOrderTemplate,
          PRIVILEGE.settingEdmSetting,
          PRIVILEGE.settingExchangeManage,
          PRIVILEGE.settingPaypalManage,
        ],
        subMenu: [
          {
            id: 'manageRelation',
            system: 'SALES',
            url: '/manage/relation',
            roles: [PRIVILEGE.settingAccountRelation],
          },
          {
            id: 'settingsRoles',
            system: 'SALES',
            url: '/manage/roles',
            roles: [PRIVILEGE.settingPrivilegeManage],
          },
          {
            id: 'settingsModules',
            system: 'SALES',
            url: '/manage/modules',
            roles: [PRIVILEGE.settingModuleManage],
          },
          {
            id: 'manageEmail',
            system: 'SALES',
            url: '/manage/email',
            roles: [
              PRIVILEGE.settingEmailManage,
              PRIVILEGE.settingEmailTemplate,
              PRIVILEGE.settingEmailReview,
            ],
          },
          {
            id: 'settingsOrigins',
            system: 'SALES',
            url: '/manage/origins',
            roles: [PRIVILEGE.settingOriginManage],
          },
          {
            id: 'settingsFieldsSwitch',
            system: 'SALES',
            url: '/manage/fieldsSwitch',
            roles: [PRIVILEGE.settingFieldsManage],
          },
          {
            id: 'settingsFields',
            system: 'SALES',
            url: '/manage/fieldsConfig',
            roles: [PRIVILEGE.settingFieldsManage],
          },
          {
            id: 'manageCustomer',
            system: 'SALES',
            url: '/manage/customer',
            roles: [PRIVILEGE.settingCustomerManage],
          },
          {
            id: 'opportunitySetting',
            system: 'SALES',
            url: '/manage/opportunity',
            roles: [PRIVILEGE.settingOpportunityManage],
            setting: [SETTING.opportunitySwitch],
          },
          {
            id: 'manageProduct',
            system: 'SALES',
            url: '/manage/product',
            roles: [PRIVILEGE.settingProductManage],
          },
          {
            id: 'quotationSet',
            system: 'SALES',
            url: '/manage/quotation',
            roles: [
              PRIVILEGE.settingQuotationManage,
              PRIVILEGE.settingQuotationTemplate,
            ],
            setting: [SETTING.quotationSwitch],
          },
          {
            id: 'orderSet',
            system: 'SALES',
            url: '/manage/order',
            roles: [
              PRIVILEGE.settingOrderManage,
              PRIVILEGE.settingOrderTemplate,
            ],
            setting: [SETTING.orderSwitch],
          },
          {
            id: 'manageAllocate',
            system: 'SALES',
            url: '/manage/edm',
            roles: [PRIVILEGE.settingEdmSetting],
          },
          {
            id: 'exchangeSetting',
            system: 'SALES',
            url: '/manage/exchange',
            roles: [PRIVILEGE.settingExchangeManage],
          },
          {
            id: 'payment',
            system: 'SALES',
            url: '/manage/payment',
            roles: [PRIVILEGE.settingPaypalManage],
          },
          {
            id: 'cashCollectionsSet',
            system: 'SALES',
            url: '/manage/cash-collections',
            roles: [PRIVILEGE.cashCollectionSetting],
          },
        ],
      },
      {
        id: 'salesCloud',
        system: 'SALES',
        url: '/disk',
        roles: [PRIVILEGE.settingDiskManage],
      },
      {
        id: 'salesContacts',
        system: 'SALES',
        url: '/contacts',
        roles: [PRIVILEGE.settingContactsManage],
      },
      {
        id: 'recyclePage',
        system: 'SALES',
        url: '/recycle',
        roles: [PRIVILEGE.settingRecycleManage],
      },
      {
        id: 'accountInfo',
        system: 'SALES',
        url: '/account',
        roles: [PRIVILEGE.settingAccountInfo],
      },
    ],
  },
  {
    id: 'synergy',
    icon: 'synergy',
    subMenu: [
      {
        id: 'cloud',
        system: 'CRM',
        url: '/disk',
        roles: [PRIVILEGE.functionalBase],
      },
      {
        id: 'contacts',
        system: 'CRM',
        url: '/contacts/user',
        roles: [PRIVILEGE.functionalBase],
      },
      {
        id: 'customApprove',
        system: 'CRM',
        url: '/custom-review',
        roles: [PRIVILEGE.functionalReviewBase],
        setting: [SETTING.showCustomApproval],
      },
      {
        id: 'approve',
        system: 'CRM',
        url: '/review',
        roles: [PRIVILEGE.functionalReviewBase],
      },
    ],
  },
];
